module.exports = __webpack_public_path__ + "static/media/Industry-Bold.e541176f.woff2";